/* THIS IS A GENERATED FILE, DO NOT EDIT */

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AcceptMobileTOUResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "AcceptPortalInvitationResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "AccountBulkUpdatePaymentPrefsResponseOrError": [
      "AccountBulkUpdatePaymentPrefsResponse",
      "AccountBulkUpdatePaymentPrefsValidationErrors",
      "MutationErrorResponse"
    ],
    "AccountContactMapObjectOrError": [
      "AccountContactMapObjectType",
      "MutationErrorResponse"
    ],
    "ActivateGlobalUserResponse": [
      "ActivateGlobalUserObject",
      "MutationErrorResponse"
    ],
    "ActivateResult": [
      "ApprovalPending",
      "AutomationType",
      "InvalidAutomationGraph",
      "NotFoundError"
    ],
    "ActiveArenaAccessQueryResponse": [
      "ActiveArenaAccessOutput",
      "MutationErrorResponse"
    ],
    "ActivityAISummaryResult": [
      "ActivityAISummaryResponse",
      "MutationErrorResponse"
    ],
    "ActivityFeedObjectType": [
      "CalendarEventObjectType",
      "CapitalCallObjectType",
      "DistributionObjectType",
      "EmailObjectType",
      "NetIncomeObjectType",
      "NoteObjectType",
      "StoredEmailObjectType",
      "TransactionObjectType"
    ],
    "ActivityFeedRecordOrErrorResponse": [
      "ContactActivityFeedsObjectType",
      "DashboardActivityFeedObjectType",
      "LeadActivityFeedsObjectType",
      "MutationErrorResponse",
      "PositionActivityFeedsObjectType",
      "ProspectActivityFeedObjectType"
    ],
    "ActivityObjectTypeOrError": [
      "MutationErrorResponse",
      "NoteObjectType"
    ],
    "AddContactsToPositionBulkResult": [
      "AddContactsToPositionBulkPayload",
      "MutationErrorResponse"
    ],
    "AddContactToAccountResult": [
      "AddContactToAccountPayload",
      "MutationErrorResponse"
    ],
    "AddDealContactResult": [
      "AddDealContactPayload",
      "MutationErrorResponse"
    ],
    "AddDealFundResult": [
      "AddDealFundPayload",
      "MutationErrorResponse"
    ],
    "AddDealTeamMemberResult": [
      "AddDealTeamMemberPayload",
      "MutationErrorResponse"
    ],
    "AddGroupMembershipResponse": [
      "AddGroupMembershipResult",
      "MutationErrorResponse"
    ],
    "AddressObjectTypeBase": [
      "AddressObjectType",
      "ContactAddressObjectType",
      "UserAddressObjectType"
    ],
    "AddSourcingDealContactsResult": [
      "AddSourcingDealContactsSuccess",
      "MutationErrorResponse"
    ],
    "ArenaAccessByRoleGroupsQueryResponse": [
      "ArenaAccessByRoleGroupsOutput",
      "MutationErrorResponse"
    ],
    "ArenaAccessByUsersQueryResponse": [
      "ArenaAccessByUsersOutput",
      "MutationErrorResponse"
    ],
    "ArenaSectionMutationErrorResponse": [
      "ArenaSection",
      "MutationErrorResponse"
    ],
    "ArenaSectionPublishSectionErrorResponse": [
      "ArenaSection",
      "PublishSectionErrorResponse"
    ],
    "ArenaStyleSettingsResponseOrError": [
      "ArenaStyleSettingsMutationResponse",
      "MutationErrorResponse"
    ],
    "AssetReportTemplateModuleFieldOrError": [
      "AssetReportTemplateModuleFieldObjectType",
      "MutationErrorResponse"
    ],
    "AssetReportTemplateModuleFieldsResponse": [
      "AssetReportTemplateModuleFieldResults",
      "MutationErrorResponse"
    ],
    "AssetReportTemplateModuleResponseOrError": [
      "AssetReportTemplateModuleObjectType",
      "MutationErrorResponse"
    ],
    "AssetReportTemplateResponseOrError": [
      "AssetReportTemplateObjectType",
      "MutationErrorResponse"
    ],
    "AssistantResult": [
      "AssistantDraft",
      "AssistantError"
    ],
    "AssociatePositionsWithSourcePaymentPrefObjectTypeAssociateWithPositionObjectTypeAssociatePositionsOfAccountObjectTypeAssociateLPPositionsOfAccountObjectTypeAssociatePositionsWithoutPaymentPrefObjectType": [
      "AssociateLPPositionsOfAccountObjectType",
      "AssociatePositionsOfAccountObjectType",
      "AssociatePositionsWithoutPaymentPrefObjectType",
      "AssociatePositionsWithSourcePaymentPrefObjectType",
      "AssociateWithPositionObjectType"
    ],
    "AsyncJobOrError": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "BatchPaymentRequestedResult": [
      "BatchPaymentRequestedResponse",
      "MutationErrorResponse"
    ],
    "BulkUpdateAccountResponseOrError": [
      "BulkUpdateAccountResponse",
      "MutationErrorResponse"
    ],
    "BulkUpdatePostSharingResponse": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "CanopyGroupUsersResponse": [
      "CanopyGroupUsersOutput",
      "MutationErrorResponse"
    ],
    "CashflowHistoryItem": [
      "CashflowHistoryDeltaItem",
      "CashflowHistoryDistributionItem",
      "CashflowHistoryTransactionItem"
    ],
    "ChangeRequestQueryResponseQueryErrorResponse": [
      "ChangeRequestQueryResponse",
      "QueryErrorResponse"
    ],
    "ChangeRequestReferenceObjectType": [
      "ChangeRequestedObj",
      "ContactObjectType",
      "DocumentObjectType",
      "MarketLensContactUpdateSignalObjectType",
      "MarketLensServiceProviderUpdateSignalObjectType"
    ],
    "ChatMessageMutationErrorResponse": [
      "ChatMessage",
      "MutationErrorResponse"
    ],
    "ChatMessageMutationSuccessResponseMutationErrorResponse": [
      "ChatMessage",
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "CheckIssue": [
      "DollarSignCellIssue"
    ],
    "ClearPortalUserNewLinkedArenasResponse": [
      "ClearPortalUserNewLinkedArenasObject",
      "MutationErrorResponse"
    ],
    "CommonCompanyInvestorDataInterface": [
      "LLCPartnershipInvestorDataObjectType",
      "TrustInvestorDataObjectType"
    ],
    "ConfigureDocumentReviewersOrError": [
      "ConfigureDocumentReviewersResponse",
      "MutationErrorResponse"
    ],
    "ConfigureIntegrationOrError": [
      "ConfigureIntegrationObject",
      "MutationErrorResponse"
    ],
    "ConfigurePreqinIntegrationResponse": [
      "MutationErrorResponse",
      "PreqinSuccessResponse"
    ],
    "ConfirmMarketLensMatchOrError": [
      "ConfirmMarketLensMatchObject",
      "MutationErrorResponse"
    ],
    "ConfirmNewEmailResponse": [
      "ConfirmNewEmailObject",
      "MutationErrorResponse"
    ],
    "ContactActivityFeedObjectType": [
      "CalendarEventObjectType",
      "EmailObjectType",
      "NoteObjectType",
      "StoredEmailObjectType"
    ],
    "ContactDeleteConfirmationObjectTypeOrError": [
      "ContactDeleteConfirmationObjectType",
      "MutationErrorResponse"
    ],
    "ContactDeletedCountObjectTypeOrError": [
      "ContactDeletedCountObjectType",
      "MutationErrorResponse"
    ],
    "ContactFilterDeletedCountObjectTypeOrError": [
      "DeletedContactFilterCountObjectType",
      "MutationErrorResponse"
    ],
    "ContactObjectTypeOrError": [
      "ContactObjectType",
      "MutationErrorResponse"
    ],
    "ContactRelationLabelObjectTypeOrError": [
      "ContactRelationLabelObjectType",
      "MutationErrorResponse"
    ],
    "ContactSearchResultValidationError": [
      "ContactSearchResult",
      "ValidationError"
    ],
    "ConvertDealToInvestmentResult": [
      "ConvertDealToInvestmentPayload",
      "MutationErrorResponse"
    ],
    "CprMutationResult": [
      "LpAccessRoleObjectType",
      "MutationErrorResponse"
    ],
    "CprSortOrdersResult": [
      "MutationErrorResponse",
      "UpdateCprSortOrdersSuccess"
    ],
    "CreateArenaAccessOrError": [
      "CreateArenaAccessResponse",
      "MutationErrorResponse"
    ],
    "CreateBankAccountResponse": [
      "CreateBankAccountSuccessResponse",
      "MutationErrorResponse"
    ],
    "CreateBulkArenaAccessOrError": [
      "CreateBulkArenaAccessResponse",
      "MutationErrorResponse"
    ],
    "CreateContactRelationResponse": [
      "ContactRelationObjectType",
      "MutationErrorResponse"
    ],
    "CreateDealFromSaleEventResult": [
      "CreateDealPayload",
      "MutationErrorResponse"
    ],
    "CreateDealResult": [
      "CreateDealPayload",
      "MutationErrorResponse"
    ],
    "CreateDocumentVersionResponse": [
      "DocumentVersionObjectType",
      "MutationErrorResponse"
    ],
    "CreateFolderDocumentsResponse": [
      "FolderDocumentResults",
      "MutationErrorResponse"
    ],
    "CreateGridSavedViewResult": [
      "GridSavedView",
      "MutationErrorResponse"
    ],
    "CreateIntegrationDetailsOrError": [
      "IntegrationDetailsObjectType",
      "MutationErrorResponse"
    ],
    "CreateLpConsolidationResponse": [
      "LpConsolidationRequestObject",
      "MutationErrorResponse"
    ],
    "CreateLpQuestionnaireChatThreadAsGpResponseMutationErrorResponse": [
      "CreateLpQuestionnaireChatThreadAsGpResponse",
      "MutationErrorResponse"
    ],
    "CreateLpQuestionnaireChatThreadAsLpResponseMutationErrorResponse": [
      "CreateLpQuestionnaireChatThreadAsLpResponse",
      "MutationErrorResponse"
    ],
    "CreateMultipleContactsOrError": [
      "CreateMultipleContactsResponse",
      "MutationErrorResponse"
    ],
    "CreateOrUpdateActivityTypeResponse": [
      "ActivityTypeObjectType",
      "MutationErrorResponse"
    ],
    "CreatePayableResponseOrError": [
      "CreatePayableResponse",
      "MutationErrorResponse"
    ],
    "CreatePositionIncreaseResult": [
      "MutationErrorResponse",
      "PositionIncreaseObjectType"
    ],
    "CreateProspectResult": [
      "MutationErrorResponse",
      "ProspectObjectType"
    ],
    "CreateSourcingDealResult": [
      "CreateSourcingDealSuccess",
      "MutationErrorResponse"
    ],
    "CreateSourcingOfferingResult": [
      "CreateSourcingOfferingSuccess",
      "MutationErrorResponse"
    ],
    "CreateSourcingSavedSearchResult": [
      "MutationErrorResponse",
      "SourcingSavedSearch"
    ],
    "CreateStoredEmailResponse": [
      "StoredEmailAlreadyExistsResponse",
      "StoredEmailObjectType"
    ],
    "DashboardActivityUnionFeedObjectType": [
      "CalendarEventObjectType",
      "CapitalCallBatchObjectType",
      "CapitalCallObjectType",
      "DistributionBatchObjectType",
      "EmailBatchObjectType",
      "EmailObjectType",
      "ManagementFeeBatchObjectType",
      "NetIncomeBatchObjectType",
      "NoteObjectType",
      "StoredEmailObjectType",
      "TransactionObjectType"
    ],
    "DashboardBackfillStatusResponse": [
      "DashboardBackfillStatusResult",
      "MutationErrorResponse"
    ],
    "DatetimeFormatPreferencesResponse": [
      "MutationErrorResponse",
      "UpdateDatetimeFormatPreferencesObject"
    ],
    "DecideApprovalResult": [
      "AutomationApprovalType",
      "NotAuthorized",
      "NotFoundError"
    ],
    "DeclinePortalInvitationResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "DecryptSubscriptionSnapshotFieldsOrError": [
      "DecryptSubscriptionSnapshotFieldsObject",
      "MutationErrorResponse"
    ],
    "DeleteAssetLocationResponse": [
      "DeleteAssetLocationObject",
      "MutationErrorResponse"
    ],
    "DeleteAssetResponse": [
      "DeleteAssetObject",
      "MutationErrorResponse"
    ],
    "DeleteAutomationResult": [
      "AutomationDeleteBlocked",
      "AutomationType",
      "NotFoundError"
    ],
    "DeleteCanopyUserAndArenaAccessesOrError": [
      "DeleteCanopyUserAndArenaAccessesResponse",
      "MutationErrorResponse"
    ],
    "DeleteContactRelationResponse": [
      "DeleteContactRelationSuccess",
      "MutationErrorResponse"
    ],
    "DeleteFieldAccessRoleResponse": [
      "DeleteFieldAccessRoleObject",
      "MutationErrorResponse"
    ],
    "DeleteFolderDocumentResponse": [
      "FolderDocument",
      "MutationErrorResponse"
    ],
    "DeleteFolderResponse": [
      "DocumentFolder",
      "MutationErrorResponse"
    ],
    "DeleteGridSavedViewResult": [
      "DeleteGridSavedViewSuccess",
      "MutationErrorResponse"
    ],
    "DeleteLabelDisplaySettingOrError": [
      "DeleteLabelDisplaySettingResponse",
      "MutationErrorResponse"
    ],
    "DeleteProspectResult": [
      "DeleteProspectSuccessType",
      "MutationErrorResponse"
    ],
    "DeleteSourcingSavedSearchResult": [
      "DeleteSourcingSavedSearchSuccess",
      "MutationErrorResponse"
    ],
    "DiligenceDataObjectType": [
      "IndividualDiligenceDataObjectType",
      "InstitutionDiligenceDataObjectType"
    ],
    "DisableIntegrationOrError": [
      "DisableIntegrationObject",
      "MutationErrorResponse"
    ],
    "DisableProvenanceConnectionResponse": [
      "DisableProvenanceConnectionSuccessResponse",
      "MutationErrorResponse"
    ],
    "DisableResult": [
      "AutomationType",
      "NotFoundError"
    ],
    "DocumentEnrichment": [],
    "DocumentParentObjectType": [
      "AccountObjectType",
      "OfferingObjectType",
      "PositionObjectType",
      "ProspectObjectType"
    ],
    "DocumentReviewerSettingsOrError": [
      "DocumentReviewerSettingsObjectType",
      "GraphQLErrorObject",
      "MutationErrorResponse"
    ],
    "DowngradeStaffOrHybridUserToEmail2FAResponse": [
      "DowngradeStaffOrHybridUserToEmail2FAObject",
      "MutationErrorResponse"
    ],
    "DownloadComplianceDocumentsResponse": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "DownloadSubscriptionDocumentsResponse": [
      "DownloadSubscriptionDocumentsObject",
      "MutationErrorResponse"
    ],
    "DuplicateProspectObjectTypeOrError": [
      "DuplicateProspectObjectType",
      "MutationErrorResponse"
    ],
    "EditArenaResponse": [
      "EditArenaObject",
      "MutationErrorResponse"
    ],
    "EditContactsBulkResult": [
      "EditContactsBulkPayload",
      "MutationErrorResponse"
    ],
    "EditDataRoomConfigurationSettingsResponseOrError": [
      "EditDataRoomConfigurationSettingsResponse",
      "MutationErrorResponse"
    ],
    "EditExtensionFieldsErrors": [
      "EditExtensionFieldsResult",
      "MutationErrorResponse"
    ],
    "EditFolderDocumentsResponse": [
      "FolderDocument",
      "MutationErrorResponse"
    ],
    "EditorTemplateOrError": [
      "EditorTemplateObjectType",
      "MutationErrorResponse"
    ],
    "EditPortalHeroMetricsConfigResponse": [
      "MutationErrorResponse",
      "PortalHeroMetricsConfigObjectType"
    ],
    "EditUserLookerViewResponse": [
      "EditUserLookerViewObject",
      "MutationErrorResponse"
    ],
    "EmailAddressObjectTypeBase": [
      "ContactEmailAddressObjectType"
    ],
    "EmailAttachmentObjectType": [
      "DocumentObjectType",
      "RestrictedDocumentObjectType"
    ],
    "EmailBatchOrError": [
      "EmailBatchObjectType",
      "MutationErrorResponse"
    ],
    "EmailBatchRecipientsVerificationJobOrError": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "EmailBatchSendResponse": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "EmailContent": [
      "EmailBatchObjectType"
    ],
    "EndArenaAccessOrError": [
      "EndArenaAccessResponse",
      "MutationErrorResponse"
    ],
    "EndBulkArenaAccessOrError": [
      "EndBulkArenaAccessResponse",
      "MutationErrorResponse"
    ],
    "EnrollResult": [
      "AutomationEnrollmentType",
      "EnrollmentUnavailable",
      "NotFoundError"
    ],
    "EntitySubscriptionSettingsMutationErrorResponse": [
      "EntitySubscriptionSettings",
      "MutationErrorResponse"
    ],
    "EnvelopeDetails": [
      "ESignatureEntityEnvelopeDetails",
      "ESignatureOfferingEnvelopeDetails",
      "SubscriptionEmbeddedEnvelopeDetails"
    ],
    "ESignatureRequestObjectObjectType": [
      "AccountObjectType",
      "OfferingObjectType"
    ],
    "ESignatureRequestRecipientObjectObjectType": [
      "PositionObjectType",
      "ProspectObjectType"
    ],
    "ESignatureRequestTemplateObjectTypeOrError": [
      "ESignatureRequestTemplateObjectType",
      "MutationErrorResponse"
    ],
    "ESignatureSendReminderEmailRecipientsListOrError": [
      "ESignatureSendReminderEmailRecipientsResponse",
      "MutationErrorResponse"
    ],
    "ExcelExportInvestmentsPortalOrError": [
      "ExcelExportInvestmentsPortalObject",
      "MutationErrorResponse"
    ],
    "ExportActivitiesFeedsOrError": [
      "ExportActivitiesFeedsObject",
      "MutationErrorResponse"
    ],
    "ExportArenaAccessOrError": [
      "ExportArenaAccessResponse",
      "MutationErrorResponse"
    ],
    "ExportContactsOrError": [
      "ExportContactsObject",
      "MutationErrorResponse"
    ],
    "ExportInvestmentsOrError": [
      "ExportInvestmentsObject",
      "MutationErrorResponse"
    ],
    "ExportPortalHeroMetricsExcelResponse": [
      "MutationErrorResponse",
      "PortalHeroMetricsExportStatusObjectType"
    ],
    "ExportSubscriptionSnapshotsOrError": [
      "ExportSubscriptionSnapshotsObject",
      "MutationErrorResponse"
    ],
    "ExternalSsoConfigurationResponse": [
      "ExternalSsoConfigurationOutput",
      "MutationErrorResponse"
    ],
    "FirmSearchResultValidationError": [
      "FirmSearchResult",
      "ValidationError"
    ],
    "FolderDocumentOrError": [
      "FolderDocument",
      "FolderDocumentError"
    ],
    "GenerateEmailAIContentResponse": [
      "GenerateEmailAIContentResult",
      "MutationErrorResponse"
    ],
    "GenerateTotpQrCodeResponse": [
      "GenerateTotpQrCodeOutput",
      "MutationErrorResponse"
    ],
    "GridViewObjectTypeOrError": [
      "GridViewObjectType",
      "MutationErrorResponse"
    ],
    "ImportContactsOrError": [
      "ImportContactsObject",
      "MutationErrorResponse"
    ],
    "ImportDealsFromFileResult": [
      "ImportDealsFromFilePayload",
      "MutationErrorResponse"
    ],
    "ImportMarketLensEntitiesOrError": [
      "ImportMarketLensEntitiesObject",
      "MutationErrorResponse"
    ],
    "InitiateBulkCountersignResponse": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "IntegrationEntityDetailsContactSyncObjectTypeOrError": [
      "IntegrationEntityDetailsContactSyncObjectType",
      "MutationErrorResponse"
    ],
    "InvestmentLinkedObject": [
      "AssetObjectType",
      "PositionObjectType"
    ],
    "InvestmentObjectType": [
      "InvestmentTreeNode"
    ],
    "InvestorDataObjectType": [
      "AccountObjectType",
      "IndividualInvestorDataObjectType",
      "LLCPartnershipInvestorDataObjectType",
      "TrustInvestorDataObjectType"
    ],
    "InvestorDiligenceObjectObjectType": [
      "AccountObjectType",
      "ContactObjectType",
      "SubscriptionObjectType"
    ],
    "InvitationObjectTypeOrError": [
      "InvitationCountObjectType",
      "MutationErrorResponse"
    ],
    "LeadActivityFeedObjectType": [
      "NoteObjectType",
      "StoredEmailObjectType"
    ],
    "LinkedBatchObjectType": [
      "CapitalCallBatchObjectType",
      "DistributionBatchObjectType"
    ],
    "LpInviteCollaboratorResponse": [
      "LpInviteCollaboratorSuccessResponse",
      "MutationErrorResponse"
    ],
    "LpRemoveCollaboratorResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "LpUpdateCollaboratorShareAccessResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "ManageObjectGroupMembershipBulkObjectTypeOrError": [
      "ManageObjectGroupMembershipBulkObjectType",
      "MutationErrorResponse"
    ],
    "MarketLensContactValidationError": [
      "MarketLensContact",
      "ValidationError"
    ],
    "MarketLensFirmValidationError": [
      "MarketLensFirm",
      "ValidationError"
    ],
    "MatchAndShareDocumentCollectionResponse": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "MatchResultConnectionValidationError": [
      "MatchResultConnection",
      "ValidationError"
    ],
    "MatchResultsByCompanyConnectionValidationError": [
      "MatchResultsByCompanyConnection",
      "ValidationError"
    ],
    "MatchResultValidationError": [
      "MatchResult",
      "ValidationError"
    ],
    "MatchSummaryValidationError": [
      "MatchSummary",
      "ValidationError"
    ],
    "MutationSuccessOrErrorResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "MutationSuccessResponseMutationErrorResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "NetNoticeLinkageResponse": [
      "MutationErrorResponse",
      "NetNoticeLinkResults"
    ],
    "Node": [
      "AccountBankAccountMapObjectType",
      "CurrencyObjectType",
      "PayeeLog",
      "PayeeObjectType",
      "PaymentBatchLog",
      "PaymentDocumentObject",
      "SftpUserObjectType"
    ],
    "NodePayload": [
      "ChoiceCard",
      "ConfirmCard",
      "DocumentClassificationCard",
      "FreeTextCard",
      "MarkdownCard",
      "MessageCard"
    ],
    "NodeWithProfitLoss": [
      "AccountObjectType"
    ],
    "NodeWithTimeSeries": [
      "AccountObjectType",
      "AssetAcquisitionObjectType",
      "AssetObjectType",
      "LoanObjectType"
    ],
    "NoteDeletedCountObjectTypeOrError": [
      "MutationErrorResponse",
      "NoteDeletedCountObjectType"
    ],
    "NoteOrError": [
      "MutationErrorResponse",
      "NoteObjectType"
    ],
    "NotifyDocumentPublishersResponse": [
      "MutationErrorResponse",
      "NotifyDocumentPublishersSuccessResponse"
    ],
    "NPSSurveyActionResponseOrError": [
      "MutationErrorResponse",
      "NPSSurveyActionResponse"
    ],
    "ObjectDocuments": [
      "AccountObjectType",
      "OfferingObjectType"
    ],
    "ObjectLevelEditPermissions": [
      "AccountObjectType",
      "AssetObjectType",
      "LoanObjectType",
      "PositionObjectType"
    ],
    "ObjectValueObjectType": [
      "AccountObjectType",
      "EntityCollectionObjectType",
      "UserObjectType"
    ],
    "OfferingCloseRoundObjectTypeOrMutationErrorResponse": [
      "MutationErrorResponse",
      "OfferingCloseRoundObjectType"
    ],
    "OfferingFolderObjectType": [
      "DocumentFolder",
      "PortalLoginRedirectObjectType"
    ],
    "ParseSpreadsheetResponse": [
      "MutationErrorResponse",
      "ParseSpreadsheetObject"
    ],
    "PayableReferenceObject": [
      "CapitalCallBatchObjectType",
      "DistributionBatchObjectType",
      "TransactionBatchObjectType"
    ],
    "PaymentPrefUnionObjectType": [
      "AchPaymentPrefObjectType",
      "BacsPaymentPrefObjectType",
      "BecsPaymentPrefObjectType",
      "CheckPaymentPrefObjectType",
      "EftPaymentPrefObjectType",
      "NonUsPaymentPrefObjectType",
      "SepaPaymentPrefObjectType",
      "WirePaymentPrefObjectType"
    ],
    "PaymentsReferenceObjectTypeUnion": [
      "CapitalCallBatchObjectType",
      "DistributionBatchObjectType",
      "PayableObjectType",
      "TransactionBatchObjectType"
    ],
    "PermissionCheckedNode": [
      "AccountContactLabelGroupObjectType",
      "AccountContactMapObjectType",
      "AccountObjectType",
      "ActivityTypeObjectType",
      "AgreementSignatureObjectType",
      "ArenaAccessObjectType",
      "ArenaObjectType",
      "ArenaSettingsObjectType",
      "AssetAcquisitionObjectType",
      "AssetDispositionObjectType",
      "AssetLoanMapObjectType",
      "AssetObjectType",
      "AssetReportTemplateModuleFieldObjectType",
      "AssetReportTemplateModuleObjectType",
      "AssetReportTemplateObjectType",
      "AsyncJobObjectType",
      "BankAccountObjectType",
      "BulkArenaAccessObjectType",
      "CalendarEventObjectType",
      "CapitalCallBatchObjectType",
      "CapitalCallBatchTotalObjectType",
      "CapitalCallDetailObjectType",
      "CapitalCallObjectType",
      "ComplianceSettingsObjectType",
      "ContactObjectType",
      "ContactPhotoObjectType",
      "ContactRelationKeyPersonType",
      "ContactRelationLabelObjectType",
      "ContactRelationObjectType",
      "CountryObjectType",
      "DataRoomMetricLabelObjectType",
      "DataRoomMetricObjectType",
      "DataRoomObjectType",
      "DistributionBatchObjectType",
      "DistributionBatchTotalObjectType",
      "DistributionDetailObjectType",
      "DistributionObjectType",
      "DistributionTypeObjectType",
      "DocumentCategoryObjectType",
      "DocumentFolder",
      "DocumentObjectType",
      "DocumentReviewerMemberObjectType",
      "DocumentReviewerSettingsObjectType",
      "DocumentShareObjectType",
      "DocumentUpload",
      "DocumentVersionObjectType",
      "DocumentViewObjectType",
      "DocumentWatermarkObjectType",
      "EditionObjectType",
      "EditorTemplateObjectMapObjectType",
      "EditorTemplateObjectType",
      "EmailBatchObjectType",
      "EmailDistributionListObjectType",
      "EmailObjectType",
      "EmailRecipientObjectType",
      "EntityCollectionObjectType",
      "EntityDocumentExportJobObjectType",
      "EntitySubTypeObjectType",
      "ESignatureDocumentObjectType",
      "ESignatureExecutedDocumentObjectType",
      "ESignatureGpSignerObjectType",
      "ESignatureLpSignerObjectType",
      "ESignatureRequestBatchObjectType",
      "ESignatureRequestObjectType",
      "ESignatureRequestRecipientObjectType",
      "ESignatureRequestTemplateErrorObjectType",
      "ESignatureRequestTemplateGpSignerObjectType",
      "ESignatureRequestTemplateObjectType",
      "ExtensionFieldEnumObjectType",
      "ExtensionFieldObjectType",
      "ExtensionFieldSectionObjectType",
      "ExtensionFieldValueObjectType",
      "FeatureFlagOwnerObjectType",
      "FieldAccessFieldObjectType",
      "FieldAccessPermissionsObjectType",
      "FolderDocument",
      "FormFieldConfigObjectType",
      "GroupObjectType",
      "ImportTemplateObjectType",
      "InvestmentsExportJobObjectType",
      "InvestorDiligenceCommentObjectType",
      "InvestorDiligenceEmailObjectType",
      "InvestorDiligenceObjectType",
      "InvestorGroupObjectType",
      "KycDetailObjectType",
      "KycDocumentObjectType",
      "KycDocumentVersionActivityObjectType",
      "KycDocumentVersionObjectType",
      "LabelDisplaySettingsObjectType",
      "LabelDisplayVariantObjectType",
      "LeadObjectType",
      "LeadSourceObjectType",
      "LoanMetricObjectType",
      "LoanMetricPeriodObjectType",
      "LoanMetricPeriodValueObjectType",
      "LoanObjectType",
      "LocationObjectType",
      "LpAccessRoleGrantObjectType",
      "LpAccessRoleObjectType",
      "LpAccessRoleScopeObjectType",
      "ManagementFeeBatchObjectType",
      "ManagementFeeDetailObjectType",
      "ManagementFeeObjectType",
      "ManagementFeeTypeGroupObjectType",
      "ManagementFeeTypeObjectType",
      "ManagerObjectType",
      "NavBatchObjectType",
      "NavBatchTotalObjectType",
      "NavDetailObjectType",
      "NavObjectType",
      "NavTypeObjectType",
      "NdaObjectType",
      "NetIncomeBatchObjectType",
      "NetIncomeBatchTotalObjectType",
      "NetIncomeDetailObjectType",
      "NetIncomeObjectType",
      "NetIncomeTypeObjectType",
      "NoteObjectType",
      "NotificationCampaignObjectType",
      "ObjectGroupObjectObjectType",
      "ObjectGroupObjectType",
      "OfferingCloseRoundObjectType",
      "OfferingObjectType",
      "OperatingCompanyDetailsObjectType",
      "OwnershipUnitObjectType",
      "ParallelEntityObjectType",
      "PastEmploymentObjectType",
      "PayableObjectType",
      "PaymentBatchObjectType",
      "PaymentObjectType",
      "PaymentPermissionType",
      "PaymentPrefObjectType",
      "PendingStoredEmailObjectType",
      "PerformanceMetricsObjectType",
      "PhotoObjectType",
      "PortalChartObjectType",
      "PortalChartWidgetConfigObjectType",
      "PortalHeroMetricsConfigObjectType",
      "PortalHeroMetricsObjectType",
      "PortalInvestmentConfigObjectType",
      "PortalInvestmentsExportJobObjectType",
      "PortalLayoutConfigObjectType",
      "PositionAcmMapObjectType",
      "PositionDeltaObjectType",
      "PositionObjectType",
      "PostEngagementObjectType",
      "PostObjectType",
      "PostSharingSettingsObjectType",
      "ProductTypeAndSizeObjectType",
      "ProspectContactMapObjectType",
      "ProspectObjectType",
      "PublicationObjectType",
      "ReportTemplateAllocationTypeMapObjectType",
      "ReportTemplateAllocationTypeObjectType",
      "ReportTemplateObjectType",
      "RoleObjectType",
      "SessionLogObjectType",
      "SftpConnectionObjectType",
      "SsoConfigObjectType",
      "StateCBSAObjectType",
      "StateObjectType",
      "StationeryObjectType",
      "StoredEmailObjectType",
      "SubscriptionObjectType",
      "SubscriptionReviewerObjectType",
      "SubscriptionReviewerSettingObjectType",
      "TagObjectType",
      "TaskObjectType",
      "TaxDocDeliveryPrefObjectType",
      "TicketAssigneeMapObjectType",
      "TicketContactMapObjectType",
      "TicketObjectMapObjectType",
      "TicketObjectType",
      "TransactionBatchObjectType",
      "TransactionBatchTotalObjectType",
      "TransactionDetailObjectType",
      "TransactionObjectType",
      "TransactionTypeObjectType",
      "TwrPeriodMetricObjectType",
      "UnitValueBatchObjectType",
      "UnitValueMetricObjectType",
      "UnitValueObjectType",
      "UploadTransactionFileObjectType",
      "UserLookerViewObjectType",
      "UserNotificationFrequencyObjectType",
      "UserObjectType",
      "UserPromptViewedObjectType",
      "WatchlistScreeningDetailObjectType",
      "WatchlistScreeningLogObjectType",
      "WaterfallObjectType"
    ],
    "PhoneObjectTypeBase": [
      "ContactPhoneObjectType",
      "UserPhoneObjectType"
    ],
    "PhotoInterface": [
      "ContactPhotoObjectType",
      "PhotoObjectType"
    ],
    "PortalInvestmentConfigResponse": [
      "MutationErrorResponse",
      "PortalInvestmentConfigObjectType"
    ],
    "PositionAcmObjectOrError": [
      "MutationErrorResponse",
      "PositionAcmMapObjectType"
    ],
    "PositionIncreaseInviteFormObjectTypeOrMutationErrorResponse": [
      "MutationErrorResponse",
      "PositionIncreaseInviteFormObjectType"
    ],
    "PostOrError": [
      "MutationErrorResponse",
      "PostObjectType"
    ],
    "PrepareDealConversionResult": [
      "MutationErrorResponse",
      "PrepareDealConversionPayload"
    ],
    "PresignedUploadUrlOrError": [
      "PresignedUploadUrlBatch",
      "PresignedUploadUrlError"
    ],
    "ProspectBulkActionJobOrError": [
      "MutationErrorResponse",
      "ProspectBulkActionJobObjectType"
    ],
    "ProspectLinkContactResult": [
      "MutationErrorResponse",
      "ProspectObjectType"
    ],
    "ProspectReadyForCountersignResponse": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "ProspectUnlinkContactResult": [
      "MutationErrorResponse",
      "ProspectObjectType"
    ],
    "ProviderStatusUnion": [
      "FidesProviderStatusDto",
      "ModernTreasuryProviderStatusDto"
    ],
    "PublicationOrError": [
      "MutationErrorResponse",
      "PublicationObjectType"
    ],
    "Question": [
      "FreeFormQuestion",
      "MultipleChoiceQuestion"
    ],
    "RecentlyAddedContactsResponseQueryErrorResponse": [
      "QueryErrorResponse",
      "RecentlyAddedContactsResponse"
    ],
    "RegardingObjectType": [
      "AccountObjectType",
      "CalendarEventObjectType",
      "ContactObjectType",
      "LeadObjectType",
      "OfferingObjectType",
      "PositionObjectType",
      "ProspectObjectType"
    ],
    "RejectSubscriptionForComplianceResponse": [
      "MutationErrorResponse",
      "RejectSubscriptionForComplianceSuccessResponse"
    ],
    "RemoveDealContactResult": [
      "MutationErrorResponse",
      "RemoveDealContactPayload"
    ],
    "RemoveDealFundResult": [
      "MutationErrorResponse",
      "RemoveDealFundPayload"
    ],
    "RemoveDealTeamMemberResult": [
      "MutationErrorResponse",
      "RemoveDealTeamMemberPayload"
    ],
    "RemoveGroupMembershipOrError": [
      "MutationErrorResponse",
      "RemoveGroupMembershipResponse"
    ],
    "RemovePaymentPrefFromAccountOutput": [
      "MutationErrorResponse",
      "RemovePaymentPrefFromAccountResponse"
    ],
    "RemovePaymentPrefFromPositionResponse": [
      "MutationErrorResponse",
      "RemovePaymentPrefFromPositionOutput"
    ],
    "RenameVersionResult": [
      "AutomationVersionType",
      "NotFoundError"
    ],
    "ReorderCustomSectionsResponseMutationErrorResponse": [
      "MutationErrorResponse",
      "ReorderCustomSectionsResponse"
    ],
    "ResetFormFieldConfigToDefaultResponse": [
      "MutationErrorResponse",
      "ResetFormFieldConfigToDefaultSuccess"
    ],
    "ResolveApprovalResult": [
      "AutomationAwaitType",
      "NotFoundError"
    ],
    "ReviewChangeRequestMutationResponseMutationErrorResponse": [
      "MutationErrorResponse",
      "ReviewChangeRequestMutationResponse"
    ],
    "ReviewChangeRequestObject": [
      "AddContactRequest",
      "MarketLensAddContactRequest",
      "MarketLensDepartContactRequest",
      "MarketLensEndServiceProviderRequest",
      "MarketLensNewServiceProviderRequest",
      "MarketLensUpdateContactRequest",
      "RemoveContactRequest",
      "UpdateCommunicationPrefsRequest",
      "UpdatePositionPaymentPrefRequest"
    ],
    "ReviewChangeRequestResponseQueryErrorResponse": [
      "QueryErrorResponse",
      "ReviewChangeRequestResponse"
    ],
    "RevokeConnectionResult": [
      "NotFoundError",
      "OAuthConnectionType"
    ],
    "RevokeDataRoomAccessResult": [
      "MutationErrorResponse",
      "RevokeDataRoomAccessSuccessType"
    ],
    "RevokeExternalSSOTicketResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "RunAutomationResult": [
      "ApprovalPending",
      "InvalidAutomationGraph",
      "NotFoundError",
      "QueuedRuns"
    ],
    "SavedContactFilterObjectTypeOrError": [
      "MutationErrorResponse",
      "SavedContactFilterObjectType"
    ],
    "SaveDraftResult": [
      "DraftType",
      "NotFoundError",
      "OptimisticLockConflict"
    ],
    "SendEmailAddressVerificationResponse": [
      "MutationErrorResponse",
      "SendEmailAddressVerificationObject"
    ],
    "SetDealDispositionResult": [
      "MutationErrorResponse",
      "SetDealDispositionPayload"
    ],
    "SetDefaultGridSavedViewResult": [
      "MutationErrorResponse",
      "SetDefaultGridSavedViewSuccess"
    ],
    "SetPrimaryDealFundResult": [
      "MutationErrorResponse",
      "SetPrimaryDealFundPayload"
    ],
    "SetProspectNdaRequirementResult": [
      "MutationErrorResponse",
      "SetProspectNdaRequirementSuccessType"
    ],
    "SetSourcingDealFeedbackResult": [
      "MutationErrorResponse",
      "SetSourcingDealFeedbackSuccess"
    ],
    "SetSourcingWatchlistResult": [
      "MutationErrorResponse",
      "SetSourcingWatchlistSuccess"
    ],
    "SettingsAddTaskResponseOrError": [
      "MutationErrorResponse",
      "SettingsAddTaskResponse"
    ],
    "SftpConnectionOrError": [
      "MutationErrorResponse",
      "SftpConnectionObjectType"
    ],
    "SftpUserOrError": [
      "MutationErrorResponse",
      "SftpUserObjectType"
    ],
    "ShareResult": [
      "AutomationShareType",
      "NotFoundError"
    ],
    "SingleIntegrationEntityDetailsContactSyncObjectTypeOrError": [
      "MutationErrorResponse",
      "SingleIntegrationEntityDetailsContactSyncObjectType"
    ],
    "StartDashboardDataBackfillResponse": [
      "MutationErrorResponse",
      "StartDashboardDataBackfillResult"
    ],
    "StartEntityDocumentExportOrError": [
      "MutationErrorResponse",
      "StartEntityDocumentExportObject"
    ],
    "SubmitChangeRequestResponseMutationErrorResponse": [
      "MutationErrorResponse",
      "SubmitChangeRequestResponse"
    ],
    "SubmitForReviewResult": [
      "AutomationApprovalType",
      "InvalidAutomationGraph",
      "NotFoundError"
    ],
    "SubscriptionAccountInfoObjectType": [
      "IndividualInvestorDataObjectType",
      "LLCPartnershipInvestorDataObjectType",
      "TrustInvestorDataObjectType"
    ],
    "SubscriptionAccountObjectType": [
      "SubscriptionAccountEntityObjectType",
      "SubscriptionAccountIndividualObjectType",
      "SubscriptionAccountJointObjectType",
      "SubscriptionAccountTrustObjectType"
    ],
    "SubscriptionContactOrErrorResponse": [
      "MutationErrorResponse",
      "SubscriptionContactObjectType"
    ],
    "SubscriptionCounterpartyOrErrorResponse": [
      "MutationErrorResponse",
      "SubscriptionCounterpartyObjectType"
    ],
    "SubscriptionMainStageStartedResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "SubscriptionOrErrorResponse": [
      "MutationErrorResponse",
      "SubscriptionV2ObjectType"
    ],
    "SubscriptionPresignedUrlsMutationErrorResponse": [
      "MutationErrorResponse",
      "SubscriptionPresignedUrls"
    ],
    "SubscriptionsObjectTypeOrError": [
      "MutationErrorResponse",
      "SubscriptionListType"
    ],
    "TableColumnResult": [
      "NotFoundError",
      "TableColumnType"
    ],
    "TableResult": [
      "NotFoundError",
      "PlaybookTableType"
    ],
    "TableRowResult": [
      "NotFoundError",
      "TableRowType"
    ],
    "TableSavedViewResult": [
      "NotFoundError",
      "TableSavedViewType"
    ],
    "TaggableObjectType": [
      "AccountObjectType",
      "ContactObjectType"
    ],
    "TagOrErrorResponse": [
      "MutationErrorResponse",
      "TagObjectType"
    ],
    "TicketAssociatedObjectUnion": [
      "AccountObjectType",
      "ContactObjectType",
      "OfferingObjectType"
    ],
    "TicketOrError": [
      "MutationErrorResponse",
      "TicketObjectType"
    ],
    "TimelineNodeEvent": [
      "EnumerationTriggered",
      "TimelineNodePatched",
      "TimelineNodeUpserted"
    ],
    "TimeSeriesFieldWrapperObjectType": [
      "TimeSeriesDateObjectType",
      "TimeSeriesFloatObjectType",
      "TimeSeriesIntObjectType",
      "TimeSeriesRangeObjectType",
      "TimeSeriesStringObjectType",
      "TimeSeriesWalletObjectType"
    ],
    "ToggleAiEnabledResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "TransactionDescriptionResponse": [
      "TransactionDescriptionNotFoundResponse",
      "TransactionDescriptionObjectType"
    ],
    "TransactionDownloadResponse": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "TransactionInstanceBatchObjectType": [
      "CapitalCallBatchObjectType",
      "DistributionBatchObjectType",
      "ManagementFeeBatchObjectType",
      "NavBatchObjectType",
      "NetIncomeBatchObjectType",
      "TransactionBatchObjectType",
      "UnitValueBatchObjectType"
    ],
    "TransactionTotalsObjectTypeBase": [
      "PositionMetricsObjectType",
      "TransactionTotalsObjectType"
    ],
    "TranscriptionJobOrError": [
      "TranscriptionError",
      "TranscriptionJob"
    ],
    "TranscriptionResultOrError": [
      "TranscriptionError",
      "TranscriptionResult"
    ],
    "TransitionDealStageResult": [
      "MutationErrorResponse",
      "TransitionDealStagePayload"
    ],
    "TransitionDocumentStatusOrError": [
      "MutationErrorResponse",
      "TransitionDocumentStatusResponse"
    ],
    "TwrPeriodMetricDetailsObjectType": [
      "TwrPeriodMetricPortalObjectType",
      "TwrPeriodMetricStaffObjectType"
    ],
    "UnarchiveActivityTypeResponse": [
      "MutationErrorResponse",
      "UnarchiveActivityTypeSuccessResponse"
    ],
    "UnblockFromBruteForceProtectionResponse": [
      "MutationErrorResponse",
      "MutationSuccessResponse"
    ],
    "UndeleteFolderDocumentResponse": [
      "FolderDocument",
      "MutationErrorResponse"
    ],
    "UndeleteFolderResponse": [
      "DocumentFolder",
      "MutationErrorResponse"
    ],
    "UnifiedSearchResultNode": [
      "AccountObjectType",
      "ContactObjectType",
      "OfferingObjectType"
    ],
    "UpdateArenaPaymentMethodSettingsResponse": [
      "MutationErrorResponse",
      "UpdateArenaPaymentMethodSettingsSuccessResponse"
    ],
    "UpdateBankAccountResponse": [
      "MutationErrorResponse",
      "UpdateBankAccountSuccessResponse"
    ],
    "UpdateContactRelationKeyPersonResponse": [
      "ContactRelationKeyPersonType",
      "MutationErrorResponse"
    ],
    "UpdateContactRelationLabelSortOrdersResponse": [
      "MutationErrorResponse",
      "UpdateContactRelationLabelSortOrdersSuccess"
    ],
    "UpdateContactRelationResponse": [
      "ContactRelationObjectType",
      "MutationErrorResponse"
    ],
    "UpdatedContactIdsOrError": [
      "MutationErrorResponse",
      "UpdatedContactIdsObjectType"
    ],
    "UpdatedContactOrError": [
      "ContactObjectType",
      "MutationErrorResponse"
    ],
    "UpdateDealResult": [
      "MutationErrorResponse",
      "UpdateDealPayload"
    ],
    "UpdatedIntegrationDetailsOrError": [
      "IntegrationDetailsObjectType",
      "MutationErrorResponse"
    ],
    "UpdateEmailPreferencesResponse": [
      "EmailPreferencesObjectType",
      "MutationErrorResponse"
    ],
    "UpdateEntityPaymentMethodSettingsResponse": [
      "MutationErrorResponse",
      "UpdateEntityPaymentMethodSettingsSuccessResponse"
    ],
    "UpdateFolderSharingSettingsResponse": [
      "DocumentFolder",
      "MutationErrorResponse"
    ],
    "UpdateGridSavedViewResult": [
      "GridSavedView",
      "MutationErrorResponse"
    ],
    "UpdatePaymentPrefForAccountsResponse": [
      "MutationErrorResponse",
      "UpdatePaymentPrefForAccountsOutput"
    ],
    "UpdatePaymentPrefForPositionResponse": [
      "MutationErrorResponse",
      "UpdatePaymentPrefForPositionOutput"
    ],
    "UpdatePaymentPrefForPositionsOfPaymentPrefResponse": [
      "MutationErrorResponse",
      "UpdatePaymentPrefForPositionsOfPaymentPrefOutput"
    ],
    "UpdatePaymentPrefForPositionsWithoutPaymentPrefResponse": [
      "MutationErrorResponse",
      "UpdatePaymentPrefForPositionsWithoutPaymentPrefOutput"
    ],
    "UpdateProspectResult": [
      "MutationErrorResponse",
      "ProspectObjectType"
    ],
    "UpdateSubscriptionReviewDecisionResponse": [
      "MutationErrorResponse",
      "UpdateSubscriptionReviewDecisionObject"
    ],
    "UpsertFolderResponse": [
      "DocumentFolder",
      "MutationErrorResponse"
    ],
    "UpsertFormFieldConfigsResponse": [
      "MutationErrorResponse",
      "UpsertFormFieldConfigsSuccess"
    ],
    "UpsertLabelDisplaySettingResponse": [
      "LabelDisplaySettingsObjectType",
      "MutationErrorResponse"
    ],
    "UpsertPortalChartResponse": [
      "MutationErrorResponse",
      "PortalChartObjectType"
    ],
    "UpsertPortalChartWidgetConfigResponse": [
      "MutationErrorResponse",
      "PortalChartWidgetConfigObjectType"
    ],
    "VerifySignatoriesResponse": [
      "MutationErrorResponse",
      "VerifiedSignatories"
    ],
    "VoidBulkCountersignResponse": [
      "AsyncJobObjectType",
      "MutationErrorResponse"
    ],
    "WorkspaceResourceConnection": [
      "DocumentCategoryConnection",
      "DocumentWatermarkConnection",
      "EmailDistributionListConnection",
      "NdaConnection",
      "StaffUserSummaryConnection",
      "TagSummaryConnection"
    ]
  }
};
      export default result;
    